module.exports = __webpack_public_path__ + "img/285.616c0c12.jpg";